import type * as React from 'react';

import IconButton from '@mui/material/IconButton';

import { dialogManager } from '../stores/DialogManager';

import { ExportIcon } from '@egr/xbox/egr-gui-icons/ExportIcon';

export const ShareYoutubeLinkButton: React.FC = () => {
    const { youtubeLinkId } = dialogManager.useState(['youtubeLinkId']);

    if (youtubeLinkId == null) {
        return null;
    }

    const copyToClipboard = async () => {
        const url = `https://www.youtube.com/watch?v=${youtubeLinkId}`;
        await dialogManager.copyTextToClipboard(url);
    };

    return (
        <IconButton
            onClick={copyToClipboard}
            edge="end"
            color="inherit"
            size="large"
        >
            <ExportIcon />
        </IconButton>
    );
};

ShareYoutubeLinkButton.displayName = 'ShareYoutubeLinkButton';
